import React from 'react'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from 'react-slick'
import {Image} from 'semantic-ui-react'
import "../../../../assets/css/slider.css"
export default function ImageSlider(props){


    const settings = {
        dots: true,
        infinite: true,
        speed: 700,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        swipeToSlide: true,
        arrows: true,
        className: 'slides'
    }
    return(
        <Slider {...settings}>
         {   
            props.imagesArray.map((src,i)=>(
                <div key={i}>
                    <Image fluid
                    src={src}  /> 
                </div>
            ))
        }
        </Slider>
    )
}